import { render, staticRenderFns } from "./addMarket.vue?vue&type=template&id=3a7b6484&scoped=true&"
import script from "./addMarket.vue?vue&type=script&lang=js&"
export * from "./addMarket.vue?vue&type=script&lang=js&"
import style0 from "./addMarket.vue?vue&type=style&index=0&id=3a7b6484&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7b6484",
  null
  
)

export default component.exports